<template>
  <svg
    width="17"
    height="17"
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="8.5" cy="8.5" r="8" stroke="url(#paint0_linear_64_6005)" />
    <path
      d="M11.8554 11.8561C12.1134 11.598 12.1134 11.1797 11.8554 10.9216L9.43397 8.49996L11.8561 6.07758C12.1141 5.81954 12.1141 5.40118 11.8561 5.14315C11.5981 4.8851 11.1797 4.8851 10.9217 5.14315L8.49961 7.5655L6.0775 5.14314C5.81948 4.8851 5.40114 4.8851 5.14312 5.14314C4.88511 5.40118 4.88511 5.81954 5.14312 6.07758L7.56525 8.49996L5.14381 10.9216C4.8858 11.1797 4.8858 11.598 5.14381 11.8561C5.40183 12.1141 5.82017 12.1141 6.07819 11.8561L8.49961 9.43441L10.921 11.8561C11.179 12.1141 11.5974 12.1141 11.8554 11.8561Z"
      fill="url(#paint1_linear_64_6005)"
      stroke="url(#paint2_linear_64_6005)"
      stroke-width="0.3"
    />
    <defs>
      <linearGradient
        id="paint0_linear_64_6005"
        x1="8.5"
        y1="0"
        x2="8.5"
        y2="17"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#437BE8" />
        <stop offset="1" stop-color="#0F8DFB" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_64_6005"
        x1="8.49961"
        y1="5.09961"
        x2="8.49961"
        y2="11.8996"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#437BE8" />
        <stop offset="1" stop-color="#0F8DFB" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_64_6005"
        x1="8.49961"
        y1="5.09961"
        x2="8.49961"
        y2="11.8996"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#437BE8" />
        <stop offset="1" stop-color="#0F8DFB" />
      </linearGradient>
    </defs>
  </svg>
</template>
